module.exports = __webpack_public_path__ + "819f5b5f7f0694c0bb3d092438332f45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/turtle-shell-hat.png
// module id = 2335
// module chunks = 0